export default __webpack_public_path__ + "static/media/Hall.6c133067.png";